export default "__VITE_ASSET__DtFvWgoF__"